/* eslint-disable import/no-default-export */
import { getCollapsedDrawerSections } from 'app/gamma/src/selectors/collapsibles';
import { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
import { actionCreator, createReducer } from '@trello/redux';
import {
  getSidebarValues,
  setSidebarValues,
} from 'app/gamma/src/util/application-storage/sidebar';
import { State } from 'app/gamma/src/modules/types';

// Types
interface Collapsible {
  open: boolean;
}
export interface CollapsiblesState {
  [key: string]: Collapsible;
}

// Initial state
function getCollapsedFromLocalStorage() {
  const sidebar = getSidebarValues();
  if (sidebar && sidebar.collapsedDrawerSections) {
    return sidebar.collapsedDrawerSections.reduce((prev, sectionId) => {
      return {
        ...prev,
        [sectionId]: {
          open: false,
        },
      };
    }, {});
  }
}

const initialState: CollapsiblesState = {
  ...getCollapsedFromLocalStorage(),
};

// Action types
const TOGGLE_COLLAPSIBLE = Symbol('ui/TOGGLE_COLLAPSIBLE');

// Reducer
export default createReducer(initialState, {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [TOGGLE_COLLAPSIBLE](state: CollapsiblesState, { payload }: any) {
    const { id, open } = payload;

    return {
      ...state,
      [id]: {
        open: state[id] ? !state[id].open : !open,
      },
    };
  },
});

// Side effects
const updateLocalStorage = (state: CollapsiblesState) => {
  const localStorageValues = getSidebarValues();
  if (localStorageValues) {
    const collapsedSections = state ? Object.keys(state) : [];
    const localStorageUpdate = {
      ...localStorageValues,
      collapsedDrawerSections: collapsedSections.filter(
        (section) => !state[section].open,
      ),
    };
    setSidebarValues(localStorageUpdate);
  }
};

// Action creators
const toggleCollapsibleAction = actionCreator(TOGGLE_COLLAPSIBLE);

// Actions
export const toggleCollapsible = (
  collapsibles: CollapsiblesState,
): StandardThunkAction => {
  return async (dispatch: Dispatch, getState: () => State) => {
    dispatch(toggleCollapsibleAction(collapsibles));

    updateLocalStorage(getCollapsedDrawerSections(getState()));
  };
};
